import React from 'react'
import classes from '@src/styles/disposal/approach.module.css'
import approach from '@src/assets/approach.jpg'

export type ApproachProps = {
  heading: string
  subHeading: string
  list: { heading: string; content: string }[]
}

function Approach({ heading, subHeading, list }: ApproachProps) {
  return (
    <section>
      <div className={classes.imageBox}>
        <img width='2627' height='495' src={approach.src} alt='Dimension waste disposal process' />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.headingContainer}>
          <h2 className={classes.title}>{heading}</h2>
          <div className={classes.subTitle}>{subHeading}</div>
        </div>
        <ol className={classes.list}>
          {list.map((item: { heading: string; content: string }) => (
            <li key={item.heading} className={classes.listItem}>
              <div className={classes.listItemContent}>
                <span>{item.heading}</span>: {item.content}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default Approach
